<template>
  <SelectBaseAntd v-bind="attrs" borderless size="middle">
    <template v-for="(comp, name) in slots" :key="name" v-slot:[name]>
      <component :is="comp" />
    </template>
  </SelectBaseAntd>
</template>
<script lang="ts">
import { useAttrs, useSlots, defineComponent } from 'vue'
import SelectBaseAntd from '@/components/base/antd/SelectBaseAntd.vue'

export default defineComponent({
  name: 'mars-select',
  inheritAttrs: false,
  components: {
    SelectBaseAntd,
  },
  setup() {
    const attrs = useAttrs()
    const slots = useSlots()
    return {
      attrs,
      slots,
    }
  },
})
</script>
